import { api } from '@/shared/api'

/** Сложность задания — App\Domain\Quests\QuestTier. По одному каждой в день. */
export type QuestTier = 'easy' | 'medium' | 'hard'

/**
 * Где засчитывается задание — App\Domain\Quests\QuestScope. Необязательно:
 * старый сервер его не присылал, и тогда задание — только с людьми.
 */
export type QuestScope = 'people' | 'computer' | 'any'

export type Quest = {
  id: number
  code: string
  tier: QuestTier
  /** Формулировку присылает сервер: каталог у него, клиент не знает ни одной. */
  title: string
  target: number
  progress: number
  reward: number
  done: boolean
  scope?: QuestScope
  /** Можно ли заменить: замена одна в день, выполненное не меняется. */
  replaceable: boolean
}

export type QuestDay = {
  /** День заданий по Москве, 'YYYY-MM-DD'. */
  day: string
  quests: Quest[]
  /** Дней подряд с выполненным заданием; 0 — серия оборвана или не начиналась. */
  streak: number
  coins: number
}

export async function fetchQuests(): Promise<QuestDay> {
  const { data } = await api.get<QuestDay>('/me/quests')

  return data
}

export async function replaceQuest(id: number): Promise<QuestDay> {
  const { data } = await api.post<QuestDay>(`/me/quests/${id}/replace`)

  return data
}
